import { Unidade } from './unidade';

export class Departamento {
	idDepartamento: number;
	cdUnidadeDepartamento:string;
	dsEnderecoDepartamento:string;
	nmDepartamento:string;
	nrTelefoneDepartamento:string;
	departamentoSuperior:Departamento;
	unidade:Unidade;

}



    



